import { Component, inject, Input } from '@angular/core';
import { CredentialType } from 'enums/CredentialType';
import { Layout } from 'modules/layout';
import { CredentialRequired } from 'services/credential.service';
import { NavigationService } from 'services/navigation.service';
import { CompanyModel } from 'models/generated/Entities.GormCrm.Company';
import { ListContactComponent } from 'components/company/contact/list-contact.component';
import { CompanyInformationComponent } from 'components/company/company-information.component';
import { EditLegalCaseComponent } from './edit-legal-case.component';
import { ListView } from 'modules/list-view';
import { LegalCaseModel } from 'models/generated/Entities.GormCrm.LegalCase';
import { Pipes } from 'modules/pipes';
import { LegalCaseStatus } from 'enums/LegalCaseStatus';
import { CompanyDataProviderFactory } from 'services/company-data-provider';

@CredentialRequired(CredentialType.EditLegalCases)
@Component({
	templateUrl: './view-legal-cases.component.html',
	providers: [CompanyDataProviderFactory],
	imports: [Layout, ListView, EditLegalCaseComponent, ListContactComponent, CompanyInformationComponent, Pipes]
})
export class ViewLegalCasesComponent {

	private readonly navigation = inject(NavigationService);
	private readonly dataProviderFactory = inject(CompanyDataProviderFactory);

	public LegalCaseStatus = LegalCaseStatus;
	public selectedLegalCase?: LegalCaseModel;
	public legalCases?: LegalCaseModel[];

	private _company?: CompanyModel;

	@Input() set company(company: CompanyModel | undefined) {
		this._company = company;
		if (!this.company?.id) return;
		this.dataProviderFactory.getProviderForCompanyId(this.company.id);
		this.loadLegalCases();
	}
	get company() { return this._company; }

	private async loadLegalCases() {
		this.legalCases = await this.dataProviderFactory.getProviderForCurrentScope().getLegalCases();
		this.selectedLegalCase = this.legalCases.find(lc => lc.status != LegalCaseStatus.Closed);
	}

	public close() { this.navigation.closeView(this); }
}
